export default {
      id: "unit_dashboard__humidity-usage",
      viewBox: "0 0 40 41",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__humidity",
      toString: function () {
        return this.url;
      }
    }